import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ISizeName } from '@df/core/service/client';
import { StylesService } from '@df/core/service/styles';
import { ModalConfig } from '@df/ui/modal/modal-config';
import { ModalRef } from '@df/ui/modal/modal-ref';

export namespace NModalLayoutRight {
    /**
     * Default setup for right side modal
     */
    export const getConfig = (size: ISizeName): ModalConfig => ({
        closeOnNavigation: true,
        height: '100dvh',
        width: getWidth(size),
        maxWidth: undefined,
        transformOptions: `translate3d(100%, 0px, 0px)`,
        modalClass: 'p-a-0 opacity-1',
        position: {
            top: '0',
            bottom: '0',
            right: '0'
        },
        transitionOptions: '500ms ease-in-out',
        hasBackdrop: true
    });

    export const getWidth = (size: ISizeName): string =>
        ({ S: StylesService.vw(100), M: StylesService.vw(100), L: '600px', X: '600px' })[size];
}

@Component({
    standalone: true,
    selector: 'modal-layout-right',
    templateUrl: 'modal-layout-right.html',
    styleUrl: 'modal-layout-right.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalLayoutRightComponent {
    @Input()
    modalTitle?: string;

    @Input()
    modalSubtitle?: string;

    /**
     * Dependencies
     */
    constructor(private modalRef: ModalRef<any>) {}

    /**
     * Close modal
     */
    close() {
        this.modalRef.close();
    }
}
